<template>
  <div>
    <h1 class="page-header">{{ $t('employeeStatusReason.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
          <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px;" />
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" 
				:records="resources" 
				:loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.employee_status.status }}</td>
          <td>{{ record.reason }}</td>
          <td class="text-center">
						<span class="badge badge-info" v-if="record.is_paid">Yes</span>
						<span class="badge badge-secondary" v-else>No</span>
					</td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'employeeStatusReason',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/employeeStatusReason', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.employeeStatusReason.search
      },
      set(newValue) {
        this.$store.commit('hr/employeeStatusReason/SET_SEARCH', newValue)
        this.$store.commit('hr/employeeStatusReason/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('employeeStatusReason.status') },
        { name: this.$t('employeeStatusReason.reason') },
        { name: this.$t('employeeStatusReason.isPaid'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/employeeStatusReason/fetch')
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit(record) {
      this.showForm(record)
		},
		async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/employeeStatusReason/destroy', record.status_reason_id)
          .then(response => {
            this.$store.dispatch('hr/employeeStatusReason/fetch').then(() => {
              this.$toasted.success(response.message)
              record._deleting = false
            })
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(record) {
      this.$modal.show(
        FormComponent,
        {
          editData: record
        },
        {
          height: 'auto',
          width: '20%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
				},
				{
					'before-close': this.fetchData
				}
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/employeeStatusReasons/RESET_STATE')
    next()
  }
}
</script>